var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{staticClass:"d-flex justify-content-center",attrs:{"switch":"","disabled":!this.$store.getters['Users/userIsAdmin'] && !this.$store.getters['Users/userIsAdminLite']},model:{value:(_vm.item.isPremium),callback:function ($$v) {_vm.$set(_vm.item, "isPremium", $$v)},expression:"item.isPremium"}})
}
var staticRenderFns = []

export { render, staticRenderFns }